
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import SmsNotification from "../components/smsNotification";
import Footer from "../components/footer";

function SmsNotificationPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <SmsNotification /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default SmsNotificationPage;
